import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@ui/app-router';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@ui/primitives/dropdown-menu';
import { SidebarMenuAction } from '@ui/primitives/sidebar';
import { CloudIcon, CuboidIcon, EyeIcon, MoreHorizontal } from 'lucide-react';
export function ProjectContextMenu(param) {
    let { project, organization, onOpenChange } = param;
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                asChild: true,
                children: /*#__PURE__*/ _jsxs(SidebarMenuAction, {
                    showOnHover: true,
                    "data-e2e": "LAYOUT_SIDEBAR__PROJECT_CONTEXT_MENU_TRIGGER",
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                    },
                    className: "hover:bg-sidebar rounded-[4px] cursor-pointer",
                    children: [
                        /*#__PURE__*/ _jsx(MoreHorizontal, {
                            className: "h-4 w-4"
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "sr-only",
                            children: "More options"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                side: "right",
                align: "start",
                className: "bg-popover border border-border",
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        className: "cursor-pointer hover:bg-sidebar gap-2 rounded-sm p-4 font-sans font-normal text-sm text-foreground",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            to: "/org/$organization/$project",
                            params: {
                                organization,
                                project
                            },
                            children: [
                                /*#__PURE__*/ _jsx(EyeIcon, {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                "Overview"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        className: "cursor-pointer hover:bg-sidebar gap-2 rounded-sm p-4 font-sans font-normal text-sm text-foreground",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            to: "/org/$organization/$project/applications",
                            params: {
                                organization,
                                project
                            },
                            children: [
                                /*#__PURE__*/ _jsx(CuboidIcon, {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                "Applications"
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        asChild: true,
                        className: "cursor-pointer hover:bg-sidebar gap-2 rounded-sm p-4 font-sans font-normal text-sm text-foreground",
                        children: /*#__PURE__*/ _jsxs(Link, {
                            to: "/org/$organization/$project/devops/deployment-integrations",
                            params: {
                                organization,
                                project
                            },
                            children: [
                                /*#__PURE__*/ _jsx(CloudIcon, {
                                    className: "h-4 w-4 text-muted-foreground"
                                }),
                                "Deployment integrations"
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
